import React, { useState, useEffect } from 'react';
import PersonalCodeInput from "components/components/PersonalCodeInput";
import TranslationText from "components/components/Translation/TranslationText";
import LegalEntityFunctions from "components/components/LegalEntityFunctions";

export function SmartIdPersonalCodeStep(props) {
	const [localError, setLocalError] = useState("");
	const [personalCode, setPersonalCode] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		if (props.errorMessage) {
			setIsSubmitting(false);
		}
	}, [props.errorMessage]);

	const onContinueClicked = async () => {
		if (isSubmitting) {
			return;
		}

		setLocalError("");
		const isPersonalCodeValid = validatePersonalCodeFormatting();
		if (!isPersonalCodeValid) {
			return;
		}

		setIsSubmitting(true);
		await props.onPersonalCodeSubmit(personalCode);
	}

	const validatePersonalCodeFormatting = () => {
		let isPersonalCodeValid = !!personalCode;
		let errorMessage = "";
		if (!isPersonalCodeValid) {
			errorMessage = "smart_id_add_wizard_personal_code_required_error";
		}
		else if (!LegalEntityFunctions.getPersonalCodeLengths()[props.legalEntityId].includes(personalCode.length)) {
			errorMessage = "smart_id_add_wizard_personal_code_length_error";
			isPersonalCodeValid = false;
		}
		if (!isPersonalCodeValid) {
			setLocalError(errorMessage);
		}

		return isPersonalCodeValid;
	}

	const onChange = event => {
		setPersonalCode(event.value);
		setLocalError("");
		setIsSubmitting(false);
		props.onPersonalCodeUpdated(); // Notify parent component about the change
	}

	return (
		<>
			<div className="form-group">
				<div className="page-description-row">
					<p>
						<TranslationText text={props.topTextKey} />
					</p>
				</div>
				<div className="form-row">
					<div className={`form-field ${(localError || props.errorMessage) ? "-has-error" : ""}`}>
						<label className="form-field__label">
							<TranslationText text="personal_code_text_field_label" />
						</label>
						<PersonalCodeInput
							personalCode={personalCode}
							onPersonalCodeChange={onChange}
							legalEntityId={props.legalEntityId}
						/>							
						<div className="sublabel error-msg show">
							<span>
								<TranslationText text={props.errorMessage ? props.errorMessage : localError} />
							</span>
						</div>
					</div>
				</div>
			</div>
			<hr />
			
			<button
				onClick={_ => onContinueClicked()}
				className="button full-width"
				disabled={isSubmitting}
			>
				<TranslationText text='account_found_but_no_email_page_in_login_send_link_btn' />
			</button>			
		</>
	);
}